<template>
  <div>
    <div ref="refOuter" class="position-relative" @mouseover="refOuter.onMouseOver = true" @mouseleave="refOuter.onMouseOver = false">
      <div class="overflow-hidden position-relative">
        <div class="flex" :style="computedStyle" @touchstart="viewerTouchStart" @touchmove.prevent="viewerTouchMove" @touchend="viewerTouchEnd">
          <div
            v-for="(image, index) in virtuals"
            :key="index"
            :style="`display:relative;width:100%;${isList ? 'aspect-ratio: 16 / 9;' : 'aspect-ratio: 1.515 / 1;'}`"
          >
            <img class="object-cover" :src="image" style="width: 100%; height: 100%; object-fit: cover" />
          </div>
        </div>
        <!-- Left Button -->
        <transition name="fade">
          <div class="btnArea" v-if="refOuter.onMouseOver" @click="stepDown" :style="`left: 0px;`">
            <span class="btn" style="border-radius: 0 4px 4px 0; left: 0; padding: 10px 10px 10px 5px">
              <svg viewBox="0 0 18 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 22.5172L17 1" stroke="#FEFEFE" />
                <path d="M17 44.0343L1 22.5171" stroke="#FEFEFE" />
              </svg>
            </span>
          </div>
        </transition>
        <!-- Right Button -->
        <transition name="fade">
          <div class="btnArea" v-if="refOuter.onMouseOver" @click="stepUp" :style="`right: 0px;`">
            <span class="btn" style="border-radius: 4px 0 0 4px; right: 0; padding: 10px 5px 10px 10px">
              <svg viewBox="0 0 18 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 22.5172L1 1" stroke="#FEFEFE" />
                <path d="M1 44.0343L17 22.5171" stroke="#FEFEFE" />
              </svg>
            </span>
          </div>
        </transition>
      </div>
    </div>
    <div v-if="!isList" ref="refOuter" class="position-relative" style="margin: 2px -1px 0">
      <div class="mask" @touchstart="viewerTouchStart" @touchmove.prevent="viewerTouchMove" @touchend="viewerTouchEnd">
        <div class="left" @click="stepDown"></div>
        <div class="right" @click="stepUp"></div>
      </div>
      <div class="overflow-hidden position-relative">
        <div class="flex" :style="computedthumbnailStyle">
          <div
            v-for="(image, index) in thumbnails"
            class="thumbnails"
            :key="index"
            :style="`display:relative;width:${outerSize.width / 3}px;aspect-ratio: 1.315 / 1;`"
          >
            <img
              class="object-cover"
              :src="image"
              :style="`transition: all 0.3s;width: 100%; height: 100%; object-fit: cover;opacity:${index != 2 ? 0.5 : 1};`"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ImageSlider",
  props: {
    images: {
      type: Array,
      require: true,
      default: () => [],
    },
    isList: {
      type: Boolean,
      require: false,
      default: () => true,
    },
  },
  data() {
    return {
      timer: 0,
      interval: 50,
      duration: 500,
      transitionDuration: 500,
      outerSize: {
        width: 3840,
        height: 0,
      },
      isSteppingUp: false,
      isSteppingDown: false,
      targetPosition: 0,
      autoStepUpper: null,
      virtuals: [this.images[this.images.length - 1], this.images[0], this.images.length >= 2 ? this.images[1] : this.images[0]],
      thumbnails: [
        this.images.length >= 3 ? this.images[this.images.length - 2] : this.images[0],
        this.images[this.images.length - 1],
        this.images[0],
        this.images.length >= 2 ? this.images[1] : this.images[0],
        this.images.length >= 3 ? this.images[2] : this.images[0],
      ],
      refOuter: {
        onMouseOver: false,
      },
      viewerTouchMoveXs: {
        start: 0,
        end: 0,
      },
    };
  },
  computed: {
    computedStyle() {
      let str = `width: ${this.outerSize.width * 3}px; `;
      if (this.isSteppingUp) {
        str += `transform: translate3d(-${this.outerSize.width * 2}px, 0px, 0px); transition-duration:${this.transitionDuration}ms`;
      } else if (this.isSteppingDown) {
        str += `transform: translate3d(0px, 0px, 0px); transition-duration:${this.transitionDuration}ms`;
      } else {
        str += `transform: translate3d(-${this.outerSize.width}px, 0px, 0px);`;
      }
      return str;
    },
    computedthumbnailStyle() {
      let str = `width: ${this.outerSize.width * 3}px; `;
      if (this.isSteppingUp) {
        str += `transform: translate3d(-${(this.outerSize.width / 3) * 2}px, 0px, 0px); transition-duration:${this.transitionDuration}ms`;
      } else if (this.isSteppingDown) {
        str += `transform: translate3d(0px, 0px, 0px); transition-duration:${this.transitionDuration}ms`;
      } else {
        str += `transform: translate3d(-${this.outerSize.width / 3}px, 0px, 0px);`;
      }
      return str;
    },
  },
  mounted() {
    this.updateElementSizeCache();
    window.addEventListener("resize", this.updateElementSizeCache);
    // console.log(this.images);
  },
  unmounted() {
    window.removeEventListener("resize", this.updateElementSizeCache);
  },
  methods: {
    updateElementSizeCache() {
      this.outerSize.height = this.$refs.refOuter.clientHeight;
      this.outerSize.width = this.$refs.refOuter.clientWidth;
    },
    async stepUp() {
      if (!this.isSteppingUp) {
        this.targetPosition = this.images.findIndex((item) => item === this.virtuals[2]);
        this.isSteppingUp = true;
        await new Promise((resolve) => setTimeout(resolve, Math.min(this.duration, this.transitionDuration * 2)));
        this.virtuals = [
          this.images[this.getNextSceneIndex(this.virtuals[0])],
          this.images[this.getNextSceneIndex(this.virtuals[1])],
          this.images[this.getNextSceneIndex(this.virtuals[2])],
        ];
        this.thumbnails = [
          this.images[this.getNextSceneIndex(this.thumbnails[0])],
          this.images[this.getNextSceneIndex(this.thumbnails[1])],
          this.images[this.getNextSceneIndex(this.thumbnails[2])],
          this.images[this.getNextSceneIndex(this.thumbnails[3])],
          this.images[this.getNextSceneIndex(this.thumbnails[4])],
        ];
        this.isSteppingUp = false;
      }
    },
    async stepDown() {
      if (!this.isSteppingDown) {
        this.targetPosition = this.images.findIndex((item) => item === this.virtuals[0]);
        this.isSteppingDown = true;
        await new Promise((resolve) => setTimeout(resolve, Math.min(this.duration, this.transitionDuration * 2)));
        this.virtuals = [
          this.images[this.getPreviousSceneIndex(this.virtuals[0])],
          this.images[this.getPreviousSceneIndex(this.virtuals[1])],
          this.images[this.getPreviousSceneIndex(this.virtuals[2])],
        ];
        this.thumbnails = [
          this.images[this.getPreviousSceneIndex(this.thumbnails[0])],
          this.images[this.getPreviousSceneIndex(this.thumbnails[1])],
          this.images[this.getPreviousSceneIndex(this.thumbnails[2])],
          this.images[this.getPreviousSceneIndex(this.thumbnails[3])],
          this.images[this.getPreviousSceneIndex(this.thumbnails[4])],
        ];
        this.isSteppingDown = false;
      }
    },
    getNextSceneIndex(current) {
      return (this.images.findIndex((item) => item === current) + 1) % this.images.length;
    },
    getPreviousSceneIndex(current) {
      return (this.images.findIndex((item) => item === current) + this.images.length - 1) % this.images.length;
    },
    viewerTouchStart(e) {
      this.viewerTouchMoveXs.start = e.touches[0].pageX;
      this.viewerTouchMoveXs.end = e.touches[0].pageX;
    },
    viewerTouchMove(e) {
      this.viewerTouchMoveXs.end = e.touches[0].pageX;
    },
    viewerTouchEnd() {
      if (this.viewerTouchMoveXs.start - this.viewerTouchMoveXs.end > this.outerSize.width / 3) this.stepUp();
      if (this.viewerTouchMoveXs.end - this.viewerTouchMoveXs.start > this.outerSize.width / 3) this.stepDown();
      this.viewerTouchMoveXs.start = 0;
      this.viewerTouchMoveXs.end = 0;
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  will-change: opacity;
  transition: opacity 00.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.trigger {
  cursor: pointer;
}

.flex {
  display: flex;
  align-items: start;
}

.btnArea {
  position: absolute;
  cursor: pointer;
  user-select: none;
  width: 30px;
  height: 100%;
  top: 0;
}

.btn {
  position: absolute;
  background: #2d2e31;
  opacity: 0.75;
  top: calc(50% - 23px);
}

.btn svg {
  width: 11px;
}

.btn:hover {
  opacity: 0.75 !important;
}
.thumbnails {
  /* padding: 0 1px; */
  border-right: 1px solid #fefefe;
  border-left: 1px solid #fefefe;
}
.mask {
  position: absolute;
  height: 100%;
  width: 100%;
  padding: 0 1px;
  z-index: 1;
}
.left,
.right {
  height: 100%;
  width: 33%;
  background: transparent;
  transition: all 0.3s;
  cursor: pointer;
}
.right {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
